import fixDate from "@/common/fix-date";
import IRetreat from "@/models/retreats/iretreat";
import IRetreatOverview from "@/models/retreats/iretreat-overview";
import ISeason from "@/models/seasons/iseason";
import { get, post, put, remove } from "./base-service";

const baseUrl = "retreats"

export async function getRetreats(getAll = false): Promise<ISeason[]> {

    const type = getAll ? "all" : "active";

    const response = await get(`${baseUrl}/${type}`);

    return response.json();
}

export async function getRetreat(id: string | number): Promise<IRetreatOverview> {

    const response = await get(baseUrl, id);

    return response.json();
}

export async function updateRetreat(retreat: IRetreat): Promise<boolean> {
    const newRetreat = {
        ...retreat,
        startDate: fixDate(retreat.startDate),
        endDate: fixDate(retreat.endDate)
    }

    const response = await put(`${baseUrl}`, newRetreat);

    return response.ok;
}

export async function addRetreat(retreat: IRetreat): Promise<boolean> {
    const newRetreat = {
        ...retreat,
        startDate: fixDate(retreat.startDate),
        endDate: fixDate(retreat.endDate),
        manageRooming: retreat.manageRooming ?? true
    }

    const response = await post(`${baseUrl}`, newRetreat);

    return response.ok;
}

export async function deleteRetreat(id: number): Promise<boolean> {
    const response = await remove(baseUrl, id);

    return response.json();
}